import { useContext } from 'react';
import Context from 'src/contexts/NotificationsContext';
import type { NotificationContextValue } from 'src/contexts/NotificationsContext';

const hook = (): NotificationContextValue => useContext<NotificationContextValue>(Context);

export default hook;
